<div class="container is-fluid">
  <h1 class="title">Statistik - Energi</h1>

  <!-- Energy - MONTH -->
  <div class="section">
    <h2 class="title">Förbrukning - Månad</h2>
    @if (energyReadingsMonthArr && energyReadingsMonthArr.length > 0) {
      <div>
        <table class="table is-hoverable">
          <thead>
            <tr>
              <th>Datum</th>
              <th>Förbrukning (Dag)</th>
              <th>Medeleffekt (Watt)</th>
              <th>Mintemperatur</th>
              <th>Maxtemperatur</th>
              <th>Medeltemperatur</th>
              <th>Akumulerad månadsförbrukning</th>
            </tr>
          </thead>
          <tbody>
            @for (dayReading of energyReadingsMonthArr; track dayReading) {
              <tr>
                <td>{{dayReading.dateOfReading}}</td>
                <td>{{dayReading.dayKwh}} kWh</td>
                <td>{{dayReading.avgConsumptionInWatts}}</td>
                <td>{{dayReading.minTemp}} °C</td>
                <td>{{dayReading.maxTemp}} °C</td>
                <td>{{dayReading.avgTemp}} °C</td>
                <td>{{dayReading.consumptionRunningTotal}} kWh</td>
              </tr>
            }
          </tbody>
        </table>
      </div>
    }
  </div>

  <div class="columns is-mobile section">
    <div class="column is-10 is-offset-1">
      @if (lineChartData && lineChartData.datasets && lineChartData.datasets.length > 0) {
        <canvas
          baseChart width="300" height="100" [data]="lineChartData" [options]="lineChartOptions" [type]="lineChartType" (chartHover)="chartHovered($event)" (chartClick)="chartClicked($event)">
        </canvas>
      }
    </div>
  </div>

  <div class="section">
    <!-- Energy - Per hour -->
    <h2 class="title">Förbrukning - Dag</h2>
    @if (energyReadingsDayArr && energyReadingsDayArr.length > 0) {
      <div>
        <table class="table is-hoverable">
          <thead>
            <tr>
              <th>Datum</th>
              <th>Förbrukning (Timme)</th>
              <th>Medeltemperatur</th>
              <th>Akumulerad dagsförbrukning</th>
            </tr>
          </thead>
          <tbody>
            @for (dayReading of energyReadingsDayArr; track dayReading) {
              <tr>
                <td>{{dayReading.hourOfReading | date:'yyyy-MM-dd HH:mm'}}</td>
                <td>{{dayReading.hourKwh}} kWh</td>
                <td>{{dayReading.avgTemp}} °C</td>
                <td>{{dayReading.consumptionRunningTotal}} kWh</td>
              </tr>
            }
          </tbody>
        </table>
      </div>
    }
  </div>
</div>